import { Request } from '../../Servidor/Request';

export class PavingRequest {
    private sgeppavimentacao: number;
    private nome: string;

	constructor(sgeppavimentacao: number, nome: string) {
		this.sgeppavimentacao = sgeppavimentacao;
		this.nome = nome;
	}


    /**
     * Getter sgeppavimentacao
     * @return {number}
     */
	public getSgeppavimentacao(): number {
		return this.sgeppavimentacao;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PavingStructRequest {
    private sgeppavimentacao: number;

	constructor(sgeppavimentacao: number) {
        this.sgeppavimentacao = sgeppavimentacao;
	}


    /**
     * Getter sgeppavimentacao
     * @return {number}
     */
	public getSgeppavimentacao(): number {
		return this.sgeppavimentacao;
	}

}

export class PavingStructResponse {
    private sgeppavimentacao: number;
    private nome: string;

	constructor(sgeppavimentacao: number, nome: string) {
		this.sgeppavimentacao = sgeppavimentacao;
		this.nome = nome;
	}


    /**
     * Getter sgeppavimentacao
     * @return {number}
     */
	public getSgeppavimentacao(): number {
		return this.sgeppavimentacao;
	}

    /**
     * Getter nome
     * @return {string}
     */
	public getNome(): string {
		return this.nome;
	}
}

export class PavingInteractor {
    public fetchSave(request: PavingRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/pavimentacao/salvar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PavingStructRequest): PromiseLike<PavingStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("propriedade/pavimentacao/buscar", request).then((rs) => {
                if(rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}